// Minimal copy of your sweep math so overlay drawers can clip to walls.

const EPS = 1e-6;
const clamp = (v,a,b) => Math.max(a, Math.min(b, v));

function rayCircleTOI(p0x, p0y, vx, vy, cx, cy, r) {
  const dx = p0x - cx, dy = p0y - cy;
  const a = vx*vx + vy*vy + EPS;
  const b = 2 * (vx*dx + vy*dy);
  const c = dx*dx + dy*dy - r*r;
  const disc = b*b - 4*a*c;
  if (disc < 0) return null;
  const s = Math.sqrt(Math.max(0, disc));
  const t1 = (-b - s) / (2*a);
  const t2 = (-b + s) / (2*a);
  let t = Number.POSITIVE_INFINITY;
  if (t1 >= 0 && t1 <= 1) t = Math.min(t, t1);
  if (t2 >= 0 && t2 <= 1) t = Math.min(t, t2);
  if (!Number.isFinite(t)) return null;
  const px = p0x + vx*t, py = p0y + vy*t;
  const nx = (px - cx), ny = (py - cy);
  const L = Math.hypot(nx, ny) || 1;
  return { t, nx: nx/L, ny: ny/L, cx, cy };
}

export function sweepCircleVsSegmentCapsule(p0x,p0y,p1x,p1y,r,x1,y1,x2,y2){
  const vx = p1x - p0x, vy = p1y - p0y;

  const sx = x2 - x1, sy = y2 - y1;
  const segLen = Math.hypot(sx, sy);
  if (segLen < 1e-7) return rayCircleTOI(p0x,p0y,vx,vy,x1,y1,r);

  const tx = sx / segLen, ty = sy / segLen;
  const nx = -ty, ny = tx;

  const hits = [];
  const denom = vx*nx + vy*ny;
  if (Math.abs(denom) > 1e-8) {
    const s0 = ((p0x - x1)*nx + (p0y - y1)*ny);
    const cand = [ ( r - s0) / denom, (-r - s0) / denom ];
    for (const t of cand) {
      if (t < 0 || t > 1) continue;
      const qx = p0x + vx*t, qy = p0y + vy*t;
      const u = ((qx - x1)*tx + (qy - y1)*ty) / segLen;
      if (u >= -1e-6 && u <= 1+1e-6) {
        const side = ((qx - x1)*nx + (qy - y1)*ny) >= 0 ? 1 : -1;
        hits.push({
          t,
          nx: nx*side, ny: ny*side,
          cx: x1 + tx * clamp(u, 0, 1) * segLen,
          cy: y1 + ty * clamp(u, 0, 1) * segLen
        });
      }
    }
  }
  const cap1 = rayCircleTOI(p0x,p0y,vx,vy,x1,y1,r);
  const cap2 = rayCircleTOI(p0x,p0y,vx,vy,x2,y2,r);
  if (cap1) hits.push(cap1);
  if (cap2) hits.push(cap2);

  if (!hits.length) return null;
  let best = hits[0];
  for (let i=1;i<hits.length;i++) if (hits[i].t < best.t) best = hits[i];
  return { hit:true, time:best.t, nx:best.nx, ny:best.ny, cx:best.cx, cy:best.cy };
}
